<template>
  <section>
    <div class="ActiveMinutesWrapper">
      <div class="ActiveMinutesBreakout">
        <table style="width: 420px; margin: 0 auto">
          <colgroup>
            <col width="170px" />
            <col width="110px" />
            <col width="110px" />
            <col width="110px" />
          </colgroup>
          <tbody>
            <tr>
              <td align="center" style="padding: 0">
                <div class="ActiveMinutesTotal" style="width: 100%">
                  <span class="MinutesTotal" title="total minutes in/above zone"
                    >{{ stats.inAboveZoneTime }} /</span
                  >
                  <span class="MinutesGoal" title="in/above goal">{{
                    stats.inAboveZone
                  }}</span>
                  <span class="MinutesPercent" title="in/above %"
                    >({{ stats.percent }}%)</span
                  >
                </div>
              </td>
              <td class="CellBelowZone" align="center" style="padding: 0">
                <div style="width: 100%">
                  <span
                    class="MinutesBreakoutBelowZone"
                    title="total minutes below zone"
                    >{{ stats.belowZoneTime }} /</span
                  >
                  <span class="MinutesBreakoutZoneGoal" title="below goal">{{
                    stats.minutesBelowZone
                  }}</span>
                </div>
              </td>
              <td class="CellInZone" align="center" style="padding: 0">
                <div style="width: 100%">
                  <span
                    class="MinutesBreakoutInZone"
                    title="total minutes in zone"
                    >{{ stats.inZoneTime }} /</span
                  >
                  <span class="MinutesBreakoutZoneGoal" title="in goal">{{
                    stats.minutesInZone
                  }}</span>
                </div>
              </td>
              <td class="CellAboveZone" align="center" style="padding: 0">
                <div style="width: 100%">
                  <span
                    class="MinutesBreakoutAboveZone"
                    title="total minutes above zone"
                    >{{ stats.aboveZoneTime }} /</span
                  >
                  <span class="MinutesBreakoutZoneGoal" title="above goal">{{
                    stats.minutesAboveZone
                  }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'zone-stats',
  props: {
    stats: {
      type: Object,
      default: {
        inAboveZoneTime: 0,
        inAboveZone: 0,
        percent: 0,
        belowZoneTime: 0,
        minutesBelowZone: 0,
        inZoneTime: 0,
        minutesInZone: 0,
        aboveZoneTime: 0,
        minutesAboveZone: 0,
      },
    },
  },
}
</script>
<style scoped>
</style>
